import styled from "styled-components"

import { minWidth, when } from "utils"

import CroppedImage from "components/cropped-image"

// Simple card Styles
export const SimpleAuthorsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  letter-spacing: 0.1rem;
  padding: 2.5rem 2.5rem;
  font-size: 1.2rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #222;

  ${minWidth.mobile`
    padding: 0.3rem 1.8rem 1rem;
  `}
`
export const CardDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${({ image }) => (image ? "45%" : "55%")};
  width: 100%;

  ${minWidth.mobile`
    justify-content: unset;
    width: ${({ image }) => (image ? "30rem" : "40rem")};
    height: 100%;
  `}

  ${minWidth.tablet`
    justify-content: unset;
    width: ${({ image }) => (image ? "47%" : "53%")};
    height: 100%;
  `}
`

export const NextBtnSimpleItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 2.2rem 0;
`

export const TitleSimpleItem = styled.a`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 3.24rem;
  font-size: 2.4rem;
  padding: 0rem 1.5rem 1rem;
  text-align: center;

  ${minWidth.mobile`
    margin: 0 0 1rem 0;
    padding: 0rem 2.2rem;
  `}
`

export const PreviewText = styled.div`
  padding: 0rem 2.5rem;
  text-align: center;

  ${minWidth.mobile`
    margin: 0 0 2rem 0;
    padding: 0rem 2.2rem;
  `}

  p {
    letter-spacing: 0.02em;
    font-size: 1.6rem;
    margin: 0;
  }
`

export const SimpleCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 46.3rem;
  border: #222222 solid 1px;
  margin: 8.9rem 1.8rem;

  ${minWidth.mobile`
    margin: 8.9rem 3.6rem;
    flex-direction: row-reverse;
    max-height: 28.2rem;
    min-height: unset;
  `}

  ${minWidth.tablet`
    min-height: 23.3rem;
    max-width: 72.3rem;
    margin: 3rem auto;
  `}
`

export const AuthorLabel = styled.p`
  text-transform: lowercase;
  margin: 0;
  padding: 0;
`

export const ImageCroppedSimpleItem = styled(CroppedImage)`
  width: 100%;
  height: 100%;
  padding-top: 65%;

  ${minWidth.mobile`
    padding-top: 28rem;
  `}

  ${minWidth.tablet`
    padding-top: 74%;
  `}
`

// More than one card styles
export const MainContainer = styled.div`
  border: #222 solid 1px;
  padding: 0 1.9rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: #222222 solid 1px;
  margin: 8.9rem 1.8rem;

  ${minWidth.mobile`
    padding: 0 3.2rem 2rem;
  `}

  ${minWidth.tablet`
    padding: 0 1.6rem 1.6rem;
    margin: 3rem auto;
    max-width: 78.7rem;
    width: fit-content;
  `}
`

export const NextBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 2.2rem 0;
  border-bottom: 2px #f3f3f3 solid;
  width: 100%;
  ${minWidth.tablet`
    border-bottom: none;
  `}
`

export const ReadNextContainer = styled.div`
  display: block;
  height: 100%;
  width: 100%;

  ${minWidth.tablet`
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`

export const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  margin: 1.2rem 0 1.2rem;

  ${minWidth.mobile`
    margin: 2.2rem 0 1rem;
  `}

  ${minWidth.tablet`
    max-width: 22rem;
    flex-direction: column;
    margin: 0 1.2rem 1.2rem;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  margin: 0 0 0 2rem;

  ${minWidth.tablet`
    justify-content: flex-start;
    margin: 1rem 0 0;
  `}
`

export const Title = styled.a`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 2rem;
  margin: 0;
  font-size: 1.6rem;
  text-align: start;

  ${minWidth.mobile`
    margin: 0;
    padding: 0;
  `}
`

export const ImageCropped = styled(CroppedImage)`
  width: 100%;
  height: 100%;
  padding-top: 12rem;

  ${minWidth.tablet`
    width: 100%;
    padding-top: 18rem;
  `}
`

// Global styles for recirculation component
export const NextBtn = styled.button`
  border: solid 1px #db663b;
  color: #db663b;
  text-transform: uppercase;
  padding: 0.4rem 1.6rem;
  font-weight: 500;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;

  ${when("moreThanOneCard")`
    padding: 0.5rem 6rem;

    ${minWidth.tablet`
      padding: 0.4rem 1.6rem;
    `}
  `}
`

export const AuthorName = styled.a`
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  font-size: 1.2rem;
  padding-top: 1rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #222;
  text-align: start;
  margin-left: 0rem;

  ${when("simple")`
    padding-top: 0;
    margin-left: 0.3rem;
  `}
`

export const ImageLink = styled.a`
  width: 100%;
  height: 100%;
`
